import { number, string } from 'yup';

export const residenceYearsValidation = number()
  .min(0, 'Must be at least 0')
  .nullable()
  .required('Please enter years at residence. If less than 1, enter 0');

export const residenceTypeValidation = string().nullable().required('Please select one');
